import { useEffect, useCallback, useRef } from 'react';
export function useKonamiCode(callback, sequence = [
    'ArrowUp',
    'ArrowUp',
    'ArrowDown',
    'ArrowDown',
    'ArrowLeft',
    'ArrowRight',
    'ArrowLeft',
    'ArrowRight',
    'b',
    'a',
    'Enter',
]) {
    const buffer = useRef([]);
    const keySequence = useCallback((event) => {
        if (event.defaultPrevented)
            return;
        if (event.key === sequence[buffer.current.length]) {
            buffer.current = [...buffer.current, event.key];
        }
        else {
            buffer.current = [];
        }
        if (buffer.current.length === sequence.length) {
            const bufferString = buffer.current.toString();
            const sequenceString = sequence.toString();
            if (sequenceString === bufferString) {
                callback();
            }
        }
    }, [sequence]);
    useEffect(() => {
        document.addEventListener('keydown', keySequence);
        return () => document.removeEventListener('keydown', keySequence);
    }, [keySequence]);
}
